<template>
  <AppModalSkeleton
    data-test="app-modal-skeleton"
    v-if="isLoading"
  ></AppModalSkeleton>
  <ion-modal
    v-else
    ref="modal"
    :is-open="isOpen"
    :backdrop-dismiss="false"
    @didPresent="setChatIframeVisibility('none')"
    @didDismiss="setChatIframeVisibility('block')"
    aria-labelledby="modal-title"
    aria-describedby="modal-body"
    :aria-label="title"
    role="dialog"
    data-test="app-modal"
    aria-busy="false"
  >
    <div class="content-wrapper">
      <div v-if="icon" class="icon-wrapper">
        <ion-icon
          :icon="icon"
          aria-hidden="true"
          data-test="modal-icon"
        ></ion-icon>
      </div>
      <ion-title
        id="modal-title"
        size="small"
        data-test="modal-title"
        aria-hidden="true"
      >
        {{ title }}
      </ion-title>

      <p class="body" id="modal-body" data-test="modal-body" aria-hidden="true">
        {{ body }}
      </p>
      <div class="button-wrapper">
        <AppButton
          v-if="primaryButton?.label"
          :ariaLabel="primaryButton?.label"
          data-test="primary-button"
          :label="primaryButton?.label"
          size="default"
          type="primary"
          @click="$emit('onPrimaryButtonClick')"
          :isLoading="primaryButton?.isLoading"
        />
        <AppButton
          v-if="secondaryButton?.label"
          :ariaLabel="secondaryButton?.label"
          data-test="secondary-button"
          :label="secondaryButton?.label"
          size="default"
          type="secondary"
          @click="$emit('onSecondaryButtonClick')"
          :isLoading="secondaryButton?.isLoading"
        />
      </div>
    </div>
  </ion-modal>
</template>

<script setup lang="ts">
import { IonModal, IonTitle } from "@ionic/vue";

import { setChatIframeVisibility } from "@/helpers";
import AppButton from "@/components/Common/AppButton/AppButton.vue";
import AppModalSkeleton from "@/components/Skeletons/AppModalSkeleton/AppModalSkeleton.vue";
import { defineProps } from "vue";

interface Button {
  label: string;
  icon?: string;
  isLoading?: boolean;
}
interface Props {
  isOpen: boolean;
  title?: string;
  body?: string;
  primaryButton?: Button;
  secondaryButton?: Button;
  icon?: string;
  isLoading?: boolean;
}

defineProps<Props>();
</script>
<style lang="scss" scoped>
@import "@/common/theme/breakpoints.scss";
.content-wrapper {
  padding: var(--spacing-24);
  text-align: center;
}
ion-modal {
  --border-radius: 24px;
  padding-left: var(--spacing-24);
  padding-right: var(--spacing-24);
  display: flex;
  --max-width: 312px;
  --height: auto;
  --background: var(--background-white);
}

ion-title {
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-bottom: var(--spacing-8);
  padding: var(--spacing-0);
}

.body {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin-top: var(--spacing-0);
  margin-bottom: var(--spacing-24);
  color: var(--text-secondary);
}
.icon-wrapper {
  font-size: 64px;
}
ion-icon {
  color: var(--alert-success);
}
.button-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);
}

@include breakpoint(medium) {
  ion-modal {
    --max-width: 404px;
  }
}

@include breakpoint(medium) {
  ion-modal {
    --max-width: 404px;
  }
}
</style>
